<template>
  <div>
    <!-- بطاقات المدرّسين -->
    <div class="row g-5 g-xl-10 mb-5">
      <div v-if="slotsLoading" class="text-center w-100 my-4">
        <div class="spinner-border text-success" role="status">
          <span class="visually-hidden">جاري التحميل...</span>
        </div>
        <div class="mt-2">جاري تحميل الجلسات...</div>
      </div>
      <div
        v-for="ins in instructors"
        :key="ins.id"
        class="col-md-6"
        style="margin-top: 0px"
      >
        <!-- بطاقة -->
        <div class="card mb-5 mb-xl-8 mt-5 shadow-sm">
          <div class="card-body pb-0">
            <!-- Header -->
            <div class="d-flex align-items-center mb-5">
              <div class="d-flex align-items-center flex-grow-1">
                <!-- Avatar -->
                <div class="symbol symbol-50px me-5">
                  <img
                    :src="imageUrl(ins.instructor_profile.user_img)"
                    :alt="ins.name"
                    @error="onImageError"
                  />
                </div>
                <!-- Info -->
                <div class="d-flex flex-column">
                  <span class="text-gray-900 fs-6 fw-bold text-hover-primary">
                    {{ ins.name }}
                  </span>
                  <!-- عناوين المواد -->
                </div>
              </div>
              <!-- Rating -->
              <div class="rating my-0">
                <template v-for="(filled, idx) in stars(ins.rating)" :key="idx">
                  <div class="rating-label me-1" :class="{ checked: filled }">
                    <i class="bi bi-star-fill fs-5"></i>
                  </div>
                </template>
              </div>
            </div>
            <!-- Post -->
            <div class="mb-5">
              <div class="row">
                <div class="col-md-8">
                  <div class="text-gray-800 fw-normal mb-5">
                    <div>
                      <b>تاريخ الجلسة :</b>
                      <span style="font-size: 12px">{{
                        formatDateTime(ins.start_date)
                      }}</span>
                    </div>
                    <div>
                      <b>نوع الدرس :</b>
                      <span>{{
                        ins.type === "video" ? "فيديو" : ins.type
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 text-center">
                  <span
                    class="badge badge-secondary mb-1"
                    style="margin-right: -10px"
                  >
                    {{ getDuration(ins.start_date, ins.end_date) }}
                  </span>

                  <!-- إذا الجلسة جارية الآن -->

                  <!-- إذا الجلسة لم تبدأ بعد: عرض زر استرجاع -->
                  <div class="mt-1">
                    <!-- زر تقييم الجلسة -->
                    <button
                      class="btn btn-secondary btn-sm mt-1"
                      style="font-weight: 700; font-size: 11px"
                      @click="openRatingModal(ins.id)"
                    >
                      قيّم الجلسة <i class="bi bi-star fs-5 text-dark"></i>
                    </button>

                    <div
                      class="text-muted mt-1"
                      style="font-size: 11px; font-weight: 600"
                    >
                      {{ timeUntilStart(ins) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="separator mb-4"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- الترحيل بين الصفحات -->
    <nav
      v-if="pagerMeta.total > pagerMeta.per_page"
      aria-label="صفحات المدرّسين"
    >
      <ul class="pagination justify-content-center">
        <!-- Previous -->
        <li class="page-item" :class="{ disabled: !pagerLinks.prev }">
          <a
            class="page-link"
            href="#"
            @click.prevent="goToPage(pagerLinks.prev)"
            v-html="'&laquo;'"
          ></a>
        </li>

        <!-- أرقام الصفحات -->
        <li
          v-for="link in pagerMeta.links"
          :key="link.label"
          class="page-item"
          :class="{
            active: link.active,
            disabled: !link.url,
          }"
        >
          <a
            v-if="link.url"
            class="page-link"
            href="#"
            @click.prevent="goToPage(link.url)"
            v-html="link.label"
          ></a>
          <span v-else class="page-link" v-html="link.label"></span>
        </li>

        <!-- Next -->
        <li class="page-item" :class="{ disabled: !pagerLinks.next }">
          <a
            class="page-link"
            href="#"
            @click.prevent="goToPage(pagerLinks.next)"
            v-html="'&raquo;'"
          ></a>
        </li>
      </ul>
    </nav>
  </div>
  <!-- مودال التقييم -->
  <div
    class="modal fade"
    id="ratingModal"
    tabindex="-1"
    aria-labelledby="ratingModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="ratingModalLabel">تقييم الجلسة</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="إغلاق"
          ></button>
        </div>
        <div class="modal-body text-center">
          <p class="mb-3">اختر تقييمك من 1 إلى 5</p>
          <div class="d-flex justify-content-center mb-4">
            <i
              v-for="star in 5"
              :key="star"
              class="bi fs-2 me-1"
              :class="[
                'bi-star-fill',
                star <= selectedRating ? 'text-warning' : 'text-secondary',
                'cursor-pointer',
              ]"
              @click="selectedRating = star"
            ></i>
          </div>
          <button
            class="btn btn-success"
            style="min-width: 120px"
            :disabled="selectedRating === 0 || isSubmittingRating"
            @click="submitRating"
          >
            <span v-if="!isSubmittingRating">تأكيد التقييم</span>
            <div
              v-else
              class="spinner-border spinner-border-sm text-light"
              role="status"
            ></div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";

export default {
  name: "FutureSessionsList",
  data() {
    return {
      /* --------- قائم كما هو --------- */
      categoriesData: [],
      selectedCategoryId: null,
      selectedSubCategoryId: null,
      selectedChildCategoryId: null,
      isLoading: true,
      slotsLoading: false,
      isLoggedIn: false,
      token: localStorage.getItem("access_token"),
      selectedSlotId: null,
      selectedRating: 0,
      isSubmittingRating: false,
      /* --------- جديد --------- */
      instructors: [], // البيانات التى سنعرضها
      pagerLinks: {}, // prev / next / first / last
      pagerMeta: {}, // current_page, links[], ...
      instructorImgPath: baseUrl + "/images/instructors/", // عدِّل المسار إذا لزم

      /* أي شيء آخر */
      defaultImage: "/assets/img/acad-icon.png",
    };
  },

  computed: {
    /** التخصصات حسب الفئة المختارة */
  },

  mounted() {
    this.getAvailableSlots();
  },

  methods: {
    getDuration(start, end) {
      const s = new Date(start);
      const e = new Date(end);

      // لو أي واحد منهم invalid → رجع خط فاضي
      if (isNaN(s.getTime()) || isNaN(e.getTime())) {
        return "";
      }

      const diffMs = e.getTime() - s.getTime();
      const diffMin = Math.floor(diffMs / 1000 / 60);

      if (diffMin < 60) {
        return diffMin + " دقيقة";
      } else {
        const h = Math.floor(diffMin / 60);
        const m = diffMin % 60;
        return h + " ساعة" + (m ? " و " + m + " دقيقة" : "");
      }
    },
    openRatingModal(slotId) {
      this.selectedSlotId = slotId;
      this.selectedRating = 0;

      // افتح المودال
      const modal = new bootstrap.Modal(document.getElementById("ratingModal"));
      modal.show();
    },

    async submitRating() {
      if (!this.selectedSlotId || !this.selectedRating) return;

      this.isSubmittingRating = true;

      try {
        const res = await fetch(`${apiUrl}/live-sessions/rate-session`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            slot_id: this.selectedSlotId,
            rating: this.selectedRating,
          }),
        });

        const data = await res.json();

        if (!res.ok) throw new Error(data.message || "خطأ في التقييم");

        // ✅ إظهار رسالة نجاح
        await Swal.fire({
          icon: "success",
          title: "تم التقييم",
          text: data.message || "تم إرسال التقييم بنجاح",
          confirmButtonText: "حسناً",
        });

        // إغلاق المودال
        bootstrap.Modal.getInstance(
          document.getElementById("ratingModal")
        ).hide();

        this.selectedSlotId = null;
        this.selectedRating = 0;

        // إعادة تحميل الجلسات مثلاً إذا أردت تحديث الحالة
        this.getAvailableSlots();
      } catch (err) {
        // ❌ رسالة خطأ
        await Swal.fire({
          icon: "error",
          title: "خطأ",
          text: err.message || "حدث خطأ أثناء إرسال التقييم",
          confirmButtonText: "موافق",
        });
        console.error(err);
      } finally {
        this.isSubmittingRating = false;
      }
    },

    async getAvailableSlots(pageUrl = null) {
      this.slotsLoading = true;

      const endpoint = pageUrl || `${apiUrl}/live-sessions/my-slots`;

      const payload = {
        slots_type: "past",
      };

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) throw new Error(res.status);
        this.slotsLoading = false;
        const json = await res.json();
        /* بيانات الـ API مُهيكلة هكذا: { instructors: { data: [], links:{}, meta:{} } } */
        const wrapper = json.past_slots;

        this.instructors = wrapper.data;
        this.pagerLinks = wrapper.links;
        this.pagerMeta = wrapper;
      } catch (err) {
        console.error("❌ getAvailableSlots:", err);
      } finally {
        this.slotsLoading = false;
      }
    },

    /* ---------- الإنتقال بين الصفحات ---------- */
    async goToPage(url) {
      if (!url) return;
      // الـ API يقبل استدعاء GET بالرابط الكامل، لذلك نستخدمه كما هو
      await this.getAvailableSlots(url);
    },

    /* ---------- مساعدات صغيرة للعرض ---------- */
    imageUrl(img) {
      return img ? img : this.defaultImage;
    },
    onImageError(event) {
      event.target.src = this.defaultImage;
    },
    /* يحوِّل التاريخ إلى 07/07/2025 12:30 */
    formatDateTime(dt) {
      const d = new Date(dt.replace(" ", "T")); // يدعم Safari
      return (
        d.toLocaleDateString("en-US") +
        " " +
        d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
      );
    },
    /* يحوّل 3.7 إلى مصفوفة طولها 5 لتلوين النجوم */
    stars(rating) {
      const r = Math.round(Number(rating) || 0);
      return Array.from({ length: 5 }, (_, i) => i < r);
    },
    /* هل الجلسة حالياً جارية؟ */
    timeUntilStart(session) {
      const now = new Date();
      const start = new Date(session.start_date);
      const diffMs = start - now;

      if (diffMs <= 0) return "بدأت الجلسة";

      const minutes = Math.floor(diffMs / 60000);
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      if (hours > 0) {
        return `ستبدأ الجلسة بعد ${hours} ساعة و ${remainingMinutes} دقيقة`;
      } else {
        return `ستبدأ الجلسة بعد ${remainingMinutes} دقيقة`;
      }
    },

    isLive(session) {
      const now = new Date();
      const start = new Date(session.start_date);
      const end = new Date(session.end_date);
      return now >= start && now <= end;
    },
    timeRange(slot) {
      const s = new Date(slot.start_date);
      const e = new Date(slot.end_date);
      const opts = { hour: "2-digit", minute: "2-digit" };
      return `من ${s.toLocaleTimeString(
        "en-US",
        opts
      )} إلى ${e.toLocaleTimeString("en-US", opts)}`;
    },
  },
};
</script>

<style scoped>
.swal2-container.no-flex-swal {
  display: block !important;
  text-align: center;
}

/* المودال نفسه */
.no-flex-swal {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
